// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fg4Y","colMin":"styles_colMin__1ZMHi"};